// ============================================================
// Group Buy Flats — Builder / Developer Partner Data
// One entry per logo (56 total). Each developer has:
//   id        : url-safe slug (used in /developers#<id> and "More Details")
//   name      : display name
//   logoIndex : which logo image (1-56) maps to this developer
//   tagline   : short 2-line paragraph shown under the hero carousel
//   description : longer text shown on the "More Details" expand
//   gallery   : array of 10 image URLs for the hero carousel
// ------------------------------------------------------------
// NOTE: Replace the placeholder gallery URLs + copy with the
// builder's real project photos and descriptions when available.
// The structure below is intentionally uniform so the client can
// edit a single object per builder.
// ============================================================

// A pool of high-quality real-estate stock images used to seed
// each builder's 10-image gallery. Swap these for real project
// photos per builder. We rotate through the pool with an offset
// so every builder shows a different ordering.
const IMAGE_POOL = [
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1400&q=80",
  "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1400&q=80",
  "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1400&q=80",
  "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1400&q=80",
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1400&q=80",
  "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1400&q=80",
  "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1400&q=80",
  "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1400&q=80",
  "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=1400&q=80",
  "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1400&q=80",
  "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1400&q=80",
  "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1400&q=80",
  "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=1400&q=80",
  "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1400&q=80",
  "https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=1400&q=80",
];

// Build a 10-image gallery for a given builder, rotated by offset.
function buildGallery(offset) {
  const out = [];
  for (let i = 0; i < 10; i++) {
    out.push(IMAGE_POOL[(offset + i) % IMAGE_POOL.length]);
  }
  return out;
}

// Base names — edit these to the builder's real names.
const BUILDER_NAMES = [
  "Casagrand",
    "Supadha Infra Pvt Ltd",
      "Vertex Homes",
        "Janapriya Engineers Syndicate",
          "Lansum Group",
            "Reliance Builders",
              "Nikhila Constructions",
                "Team4 Life Spaces",
                  "Mahaveer Group",
                    "Svadha Group",
                      "Prosperiti Homes",
                        "Oorjita Projects",              
  "Vision Arsha",
    "Ameya Spaces",

  "Bhanodaya Constructions",
  "Hivision Developers",
  "Profound Group",
  "Bharathi Constructions",
  "Cozy Essence Builders",
  "Ananta Realtors & Consultants",
  "Beams & Columns LLP",
  "Sri Developers",
  "GPR Farms and Ventures Pvt Ltd",
  "Sri Karthikeya Buggas",
  "Dnb Constructions",
  "Bliss Ventures Pvt",
  "Pacifica Group",


  















];

const TAGLINES = [
  "Crafting landmark residences across Hyderabad with uncompromising quality and timeless design.",
  "Trusted RERA-registered projects delivering premium living in the city's fastest-growing corridors.",
];

export const DEVELOPERS = Array.from({ length: 27 }, (_, i) => {
  const n = i + 1;
  const name = BUILDER_NAMES[i] || `Builder Partner ${n}`;
  const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") || `partner-${n}`;
  return {
    id: `${slug}-${n}`,
    name,
    logoIndex: n,
    tagline: TAGLINES[i % TAGLINES.length],
    description:
      `${name} is one of our trusted builder partners in the GroupBuy Flats network. ` +
      `Through our collective buying model, members get priority access to ${name}'s ` +
      `RERA-verified projects at negotiated group pricing. Below is a preview of their ` +
      `flagship developments — register your interest and our associates will share live ` +
      `inventory, floor plans, and the best group deal available on the day.`,
    gallery: buildGallery(i),
  };
});

export function getDeveloperById(id) {
  return DEVELOPERS.find((d) => d.id === id) || null;
}
